import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import NumberInput from "@/components/inputs/number.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {computed, onBeforeMount, PropType, ref} from "vue"
  import {
    Deliverable,
    DeliverableEnumerationResponse,
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import EnumerationSelector from "@/components/selectors/enumeration.vue"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'deliverable',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<Deliverable>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  const value = _useModel(__props, "value")

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const deliverableEnumerationResponse = ref<DeliverableEnumerationResponse>(null)

  const grossUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.gross
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.gross = input
    }
  })

  const netUnitPrice = computed({
    get() {
      if (!value.value || !value.value.unitPrice) {
        return null
      } else {
        return value.value.unitPrice.net
      }
    }, set(input: number) {
      if (!value.value || !value.value.unitPrice) {
        value.value.unitPrice = {}
      }
      value.value.unitPrice.net = input
    }
  })

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      deliverableEnumerationResponse.value = await enumerationClient.readDeliverableEnumerations()
    } catch(e) {
      error.value = e
    }
  }

  function updateGrossUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.net || value.value.unitPrice.net == 0) {
      value.value.unitPrice.gross = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.gross = value.value.unitPrice.net
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.gross = value.value.unitPrice.net * vatRatio
  }

  function updateNetUnitPrice() {
    if (!value.value.unitPrice || !value.value.unitPrice.gross || value.value.unitPrice.gross == 0) {
      value.value.unitPrice.net = 0
      return
    }
    if (!value.value.vatRate || value.value.vatRate == 0) {
      value.value.unitPrice.net = value.value.unitPrice.gross
      return
    }
    const cent = 100
    const vatRatio = (value.value.vatRate + cent) / cent
    value.value.unitPrice.net = value.value.unitPrice.gross / vatRatio
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          (deliverableEnumerationResponse.value)
            ? (_openBlock(), _createBlock(EnumerationSelector, {
                key: 0,
                selection: value.value.type,
                "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((value.value.type) = $event)),
                title: "Type",
                options: deliverableEnumerationResponse.value.types
              }, null, 8, ["selection", "options"]))
            : _createCommentVNode("", true),
          _createVNode(TextInput, {
            value: value.value.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value.value.name) = $event)),
            title: "Name",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.description,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.description) = $event)),
            title: "Description",
            readOnly: __props.readOnly,
            multiline: ""
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.ean,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((value.value.ean) = $event)),
            title: "EAN",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.memorandum,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((value.value.memorandum) = $event)),
            title: "Memorandum",
            readOnly: __props.readOnly,
            multiline: ""
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.unit,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((value.value.unit) = $event)),
            title: "Unit",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.currency,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((value.value.currency) = $event)),
            title: "Currency",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: grossUnitPrice.value,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((grossUnitPrice).value = $event)),
            title: "Gross Unit Price",
            readOnly: __props.readOnly,
            onInput: _cache[8] || (_cache[8] = ($event: any) => (updateNetUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: netUnitPrice.value,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((netUnitPrice).value = $event)),
            title: "Net Unit Price",
            readOnly: __props.readOnly,
            onInput: _cache[10] || (_cache[10] = ($event: any) => (updateGrossUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: value.value.vatRate,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((value.value.vatRate) = $event)),
            title: "VAT Rate",
            readOnly: __props.readOnly,
            onInput: _cache[12] || (_cache[12] = ($event: any) => (updateGrossUnitPrice()))
          }, null, 8, ["value", "readOnly"]),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 1,
                error: error.value,
                "onUpdate:error": _cache[13] || (_cache[13] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})